
interface V3IconChevronRightProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
    opacity?: string;
}

export const V3IconChevronRight = ({ stroke = "#ABB0BA", opacity = ".5" }: V3IconChevronRightProps) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="m6 4 4 4-4 4" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" opacity={opacity} />
</svg>
